import { createContext, useContext, useState, useEffect } from 'react';
import type { ReactNode } from 'react';
import type { LandingSiteContent } from '../types/api';
import { API_BASE_URL, SITE_SLUG } from '../config/api';

interface SiteContextProps {
  data: LandingSiteContent | null;
  loading: boolean;
  error: string | null;
}

const SiteContext = createContext<SiteContextProps>({
  data: null,
  loading: true,
  error: null,
});

// eslint-disable-next-line react-refresh/only-export-components
export const useSiteData = () => useContext(SiteContext);

export const SiteProvider = ({ children }: { children: ReactNode }) => {
  const [data, setData] = useState<LandingSiteContent | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await fetch(`${API_BASE_URL}/content?site_slug=${SITE_SLUG}`);
        if (!response.ok) {
          throw new Error('Не удалось загрузить данные сайта');
        }
        const result = await response.json();
        setData(result);
      } catch (err: unknown) {
        setError(err instanceof Error ? err.message : 'Ошибка загрузки');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return (
    <SiteContext.Provider value={{ data, loading, error }}>
      {children}
    </SiteContext.Provider>
  );
};
